export const CLEAR_COOWNER = 'CLEAR_COOWNER';
export const CLEAR_COOWNERS = 'CLEAR_COOWNERS';

export const DELETE_COOWNER = 'DELETE_COOWNER';
export const DELETE_COOWNER_ERROR = 'DELETE_COOWNER_ERROR';
export const DELETE_COOWNER_SUCCESS = 'DELETE_COOWNER_SUCCESS';

export const DELETE_SETTING_SECTION = 'DELETE_SETTING_SECTION';
export const DELETE_SETTING_SECTION_ERROR = 'DELETE_SETTING_SECTION_ERROR';
export const DELETE_SETTING_SECTION_SUCCESS = 'DELETE_SETTING_SECTION_SUCCESS';

export const GET_COOWNERS = 'GET_COOWNERS';
export const GET_COOWNERS_ERROR = 'GET_COOWNERS_ERROR';
export const GET_COOWNERS_SUCCESS = 'GET_COOWNERS_SUCCESS';

export const GET_COOWNER = 'GET_COOWNER';
export const GET_COOWNER_ERROR = 'GET_COOWNER_ERROR';
export const GET_COOWNER_SUCCESS = 'GET_COOWNER_SUCCESS';

export const SAVE_COOWNER = 'SAVE_COOWNER';
export const SAVE_COOWNER_ERROR = 'SAVE_COOWNER_ERROR';
export const SAVE_COOWNER_SUCCESS = 'SAVE_COOWNER_SUCCESS';

export const SAVE_SYNDICATE_SECTION = 'SAVE_SYNDICATE_SECTION';
export const SAVE_SYNDICATE_SECTION_ERROR = 'SAVE_SYNDICATE_SECTION_ERROR';
export const SAVE_SYNDICATE_SECTION_SUCCESS = 'SAVE_SYNDICATE_SECTION_SUCCESS';


export const UPDATE_USER = 'UPDATE_USER';
export const UPDATE_USER_TWO = 'UPDATE_USER_TWO';

export const DOWNLOAD_COOWNERS = 'DOWNLOAD_COOWNERS';
export const DOWNLOAD_COOWNERS_ERROR = 'DOWNLOAD_COOWNERS_ERROR';
export const DOWNLOAD_COOWNERS_SUCCESS = 'DOWNLOAD_COOWNERS_SUCCESS';

export const ADD_SECTION = 'ADD_SECTION';
export const ADD_SECTION_ERROR = 'ADD_SECTION_ERROR';
export const ADD_SECTION_SUCCESS = 'ADD_SECTION_SUCCESS';

export const GET_ALL_SECTION = 'GET_ALL_SECTION';
export const GET_ALL_SECTION_ERROR = 'GET_ALL_SECTION_ERROR';
export const GET_ALL_SECTION_SUCCESS = 'GET_ALL_SECTION_SUCCESS';

export const GET_ALL_SYNDICATE_SECTION = 'GET_ALL_SYNDICATE_SECTION';
export const GET_ALL_SYNDICATE_SECTION_ERROR = 'GET_ALL_SYNDICATE_SECTION_ERROR';
export const GET_ALL_SYNDICATE_SECTION_SUCCESS = 'GET_ALL_SYNDICATE_SECTION_SUCCESS';

export const GET_FIELDS = 'GET_FIELDS';
export const GET_FIELDS_ERROR = 'GET_FIELDS_ERROR';
export const GET_FIELDS_SUCCESS = 'GET_FIELDS_SUCCESS';

export const ADD_FIELDS = 'ADD_FIELDS';
export const ADD_FIELDS_ERROR = 'ADD_FIELDS_ERROR';
export const ADD_FIELDS_SUCCESS = 'ADD_FIELDS_SUCCESS';

export const ADD_ATTACHMENT = 'ADD_ATTACHMENT';
export const ADD_ATTACHMENT_ERROR = 'ADD_ATTACHMENT_ERROR';
export const ADD_ATTACHMENT_SUCCESS = 'ADD_ATTACHMENT_SUCCESS';

export const DELETE_FIELDS = 'DELETE_FIELDS';
export const DELETE_FIELDS_ERROR = 'DELETE_FIELDS_ERROR';
export const DELETE_FIELDS_SUCCESS = 'DELETE_FIELDS_SUCCESS';

export const DELETE_SYNDICATE_FIELDS = 'DELETE_SYNDICATE_FIELDS';
export const DELETE__SYNDICATE_FIELDS_ERROR = 'DELETE_SYNDICATE_FIELDS_ERROR';
export const DELETE_SYNDICATE_FIELDS_SUCCESS = 'DELETE_SYNDICATE_FIELDS_SUCCESS';

export const COOWNER_SECTION_PERMISSION = 'COOWNER_SECTION_PERMISSION';
export const COOWNER_SECTION_PERMISSION_ERROR = 'COOWNER_SECTION_PERMISSION_ERROR';
export const COOWNER_SECTION_PERMISSION_SUCCESS = 'COOWNER_SECTION_PERMISSION_SUCCESS';
export const SECTION_TOGGLE = 'SECTION_TOGGLE';
export const UPDATE_SECTION_VISIBILITY = 'UPDATE_SECTION_VISIBILITY';



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/Coowners/constants.js